import Vue from "vue";
import VueI18n from 'vue-i18n'

import de_DE from '@/translation/de_DE.json'
import en_US from '@/translation/en_US.json'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'de',
  fallbackLocale: 'de',
  messages: {
    'de': de_DE,
    'en': en_US
  }
})
